'use client';

import { format, formatDistanceToNow, isToday, isYesterday } from 'date-fns';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

type AccountInsightsUpdatedAtProps = {
  generatedAt: string;
  generatedByName?: string | null;
  className?: string;
};

function formatRelativeGeneratedAt(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return 'Unknown';

  const now = Date.now();
  const diffMs = now - date.getTime();
  if (diffMs < 60_000) return 'Just now';
  if (isToday(date)) {
    return formatDistanceToNow(date, { addSuffix: true });
  }
  if (isYesterday(date)) return 'Yesterday';
  return formatDistanceToNow(date, { addSuffix: true });
}

export function AccountInsightsUpdatedAt({
  generatedAt,
  generatedByName,
  className,
}: AccountInsightsUpdatedAtProps) {
  const relative = formatRelativeGeneratedAt(generatedAt);
  const exact = format(new Date(generatedAt), 'PPpp');

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className={cn(
              'text-xs underline-offset-2 hover:underline cursor-help text-left',
              className
            )}
          >
            Updated {relative}
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-xs text-xs">
          <p>{exact}</p>
          {generatedByName ? (
            <p className="text-muted-foreground mt-1">Generated by {generatedByName}</p>
          ) : null}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
